<template>
  <ConfigProvider
    :locale="arcoCurrentLocale"
    :global="true"
  >
    <a-alert
      v-if="show_alert"
      class="alert-banner--dark py-5"
      :show-icon="false"
      type="info"
      banner
      center
      closable
    >
      <template #title>
        <p class="text-center">{{ $t(alert_title) }}</p>
      </template>
      <div>
        <p class="text-center">{{ $t(alert_content) }}</p>
        <p
          class="text-center underline"
          v-if="getAlertLink"
          ><a
            :href="getAlertLink"
            target="_blank"
            >{{ $t('A1003') }}</a
          ></p
        >
      </div>
    </a-alert>
    <router-view class="app-container" />
  </ConfigProvider>
  <LogoutTempViewBen v-if="isTempView" />
</template>

<script>
const arcoUiLocales = import.meta.glob('/node_modules/@arco-design/web-vue/es/locale/lang/*.js');
import { initStore } from '@client/store/initStore';
import { userStore } from '@client/store/userStore';
import { ConfigProvider, Message } from '@arco-design/web-vue';
import { mapActions, mapState } from 'pinia';
import { switchDayjsLocale } from './helper/switchDayjsLocale';
import useTempView, { enterTempView } from '@client/hooks/useTempView';
import VConsole from 'vconsole';
import { defineAsyncComponent } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import dayjs from 'dayjs';
import * as corosSportConfig from '@coros/sport-config';
import { i18n } from './helper';
import { ALERT_I18N_MESSAGES, ALERT_MORE_LINKS, ALERT_TIME } from './hooks/useAlert';

const LogoutTempViewBen = defineAsyncComponent(() => import('@client/components/LogoutTempViewBtn/index.vue'));

const pathPrefix = '/node_modules/@arco-design/web-vue/es/locale/lang/';

export default {
  name: 'App',
  components: { ConfigProvider, LogoutTempViewBen },
  setup() {
    const { isTempView } = useTempView({ init: true });
    const router = useRouter();
    const route = useRoute();

    router.isReady().then(() => {
      const { debug } = route.query;
      enterTempView(route.query);

      if (debug === '1') {
        const vConsole = new VConsole();
      }
    });
    return { isTempView };
  },
  data() {
    // 初始化数据
    const initData = initStore();
    const _now = dayjs().unix();
    const is_before = ALERT_TIME.start > _now;
    const is_during = _now > ALERT_TIME.start && _now < ALERT_TIME.end;
    const is_end = _now > ALERT_TIME.end;
    const alert_title = is_before ? 'A1001' : 'A1004';
    const alert_content = is_before ? 'A1002' : 'A1005';
    const show_alert = !is_end && this.CPL_Region != '2';
    return { ...initData, arcoCurrentLocale: null, alert_title, alert_content, show_alert };
  },
  computed: {
    ...mapState(userStore, ['currentLocale']),
    ...mapState(initStore, ['warningMessageStatus', 'warningMessage']),
    getAlertLink() {
      return ALERT_MORE_LINKS[this.currentLocale] || null;
    }
  },
  watch: {
    warningMessageStatus: function (val) {
      if (!val) return;
      let content = this.$t(this.warningMessage);
      Message.warning({
        content,
        onClose: () => {
          this.updateWarningMessageStatus(false);
        }
      });
    },
    async currentLocale() {
      const arcoCurrentLocale = await this.getArcoUiLocale();
      this.arcoCurrentLocale = arcoCurrentLocale;
    }
  },
  created() {
    // 设置i8n
    this.init();
  },
  methods: {
    ...mapActions(initStore, ['updateWarningMessageStatus', 'CPL_Region']),
    ...mapActions(userStore, ['initLocaleFromClientCache']),
    async getArcoUiLocale() {
      let l = this.currentLocale;
      if (l === 'zh-TW') {
        l = 'zh-tw';
      }
      let uiLocaleModule = arcoUiLocales[`${pathPrefix}${l.toLowerCase()}.js`];
      if (!uiLocaleModule) {
        uiLocaleModule = arcoUiLocales[`${pathPrefix}en-us.js`];
      }
      return uiLocaleModule().then((v) => {
        return v.default;
      });
    },
    async init() {
      this.arcoCurrentLocale = await this.getArcoUiLocale();
      switchDayjsLocale(this.currentLocale);
      this.initLocaleFromClientCache();
      corosSportConfig.setUpT(i18n.t);
      // 更新多语言
      const locale = i18n.locale;
      if (this.CPL_Region !== '2') {
        Object.keys(ALERT_I18N_MESSAGES).forEach((locale) => {
          i18n.mergeLocaleMessage(locale, ALERT_I18N_MESSAGES[locale]);
        });
      }
    }
  }
};
</script>
<style lang="scss">
.alert-banner--dark {
  background-color: #050918 !important;
  .arco-alert-title,
  .arco-alert-content {
    color: rgba(255, 255, 255, 0.8) !important;
  }
}
</style>
